var map = {
	"./PrintScale_1.png": 67955,
	"./PrintScale_2.png": 32911,
	"./PrintScale_3.png": 21220,
	"./PrintScale_4.png": 52580,
	"./PrintScale_8.png": 13877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71705;